import { Link, useLocation } from 'react-router-dom';

interface Props {
  open: boolean,
  handleLogoutModalOpen: () => void
}

// const myImageRelease = false;

const AccountSideBar = ({ open, handleLogoutModalOpen }: Props) => {
  const location = useLocation();
  const isActive = (path: string) => (location.pathname === path ? 'active' : '');

  return (
    <nav
      id="sidebar"
      className="sidebar js-sidebar"
      style={{
        marginLeft: open ? '0px' : '-260px',
      }}
    >
      <div
        className="sidebar-content js-simplebar"
        style={{
          backgroundColor: 'rgb(29, 76, 135)',
        }}
      >
        <Link className="sidebar-brand text-center" to="/" style={{ height: '65px', background: '#fff' }}>
          <img src="/img/logo.png" alt="ビルドセルフ - BUILD-SELF" className="img-fluid" width="200" />
        </Link>
        <ul className="sidebar-nav" style={{ overflowY: 'auto' }}>
          <li className="sidebar-item pt-3">
            <Link className="account-sidebar-link" to="/">
              <i className="fa-solid fa-arrow-left fa-fw" />
              {' '}
              <span className="align-middle">メインメニューへ戻る</span>
            </Link>
          </li>

          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-header py-0">
            アカウント設定
          </li>
          <li className={`sidebar-item ${isActive('/my-account')}`}>
            <Link className="account-sidebar-link" to="/my-account">
              <i className="fa-solid fa-user-pen fa-fw" />
              {' '}
              <span className="align-middle">プロフィール変更</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/change-password')}`}>
            <Link className="account-sidebar-link" to="my-account/change-password">
              <i className="fa-solid fa-lock fa-fw" />
              {' '}
              <span className="align-middle">パスワード変更</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/plans')}`}>
            <Link to="/my-account/plans" className="account-sidebar-link">
              <i className="fa-solid fa-file-circle-check fa-fw" />
              {' '}
              <span className="align-middle">プラン情報</span>
            </Link>
          </li>
          <li className={`sidebar-item ${isActive('/my-account/payment-methods')}`}>
            <Link className="account-sidebar-link" to="/my-account/payment-methods">
              <i className="fa-solid fa-credit-card fa-fw" />
              {' '}
              <span className="align-middle">お支払方法</span>
            </Link>
          </li>

          <li className="sidebar-header py-0">
            <hr />
          </li>

          <li className="sidebar-item" onClick={handleLogoutModalOpen}>
            <a href="#" className="account-sidebar-link">
              <i className="fa-solid fa-door-open fa-fw" />
              {' '}
              <span className="align-middle">ログアウト</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default AccountSideBar;
